import React from 'react'
import './details.css'

const Details = () => {
  return (
  <div className="details">
    <div className="container">
      <div className="card">
        <h3>القسم المهني</h3>
<div className="rtl">
  1_ دورة صيانة جوالات
2_ دورة صناعة منظفات
3_ دورة ريزن
4_ دورة فن صناعة الشموع
5_ دورة اكسسوارات
6_ دورة صناعة الشوكلا
</div>

      </div>
      <div className="card">
        <h3>القسم التنموي
</h3>
<div className='rtl'>
1_ دورة اعداد مدربين tot
2_ دورة تطوير ذات
3_ دورة داعم نفسي
4_ دورة فن التواصل
5_ دورة لغة الجسد
6_ دورة الكاريزما
7_ دورة التفكير الايجابي
8_ دورة ادارة اعمال
9_ دورة ادارة موارد بشرية
</div>
      </div>
      <div className="card">
        <h3>القسم الحرفي
</h3>
<div className="rtl">
  1_ دورة مكياج
2_ دورة حلاقة نسائي
3_ دورة حلاقة رجالي
4_ دورة جل اظافر
5_ دورة العناية بالبشرة
6_ دورة تجميل علاجي
</div>
      </div>
      <div className="card">
        <h3> القسم الطبي
</h3>
<div className="rtl">
  1_ دورة مهارات تمريضية
2_ دورة اسعافات اولية
3_ دورة تمريض
4_ دورة مساعد فني مخبري
5_ دورة علاج فيزيائي
</div>
      </div>
      <div className="card">
        <h3>قسم علوم القران</h3>
<div className="rtl">
  1_ دورات تجويد
</div>
      </div>
      <div className="card">
        <h3>القسم الاعلامي
</h3>
<div className="rtl">
  1_ دورة الفصاحة والخطابة
2_ دورة ظهور اعلامي
3_ دورة اعداد صحفي
4_ دورة اعداد ممثل مسرحي
5_دورة تعليق صوتي
6_ دورة دوبلاج صوتي دراما
7_ دورة دوبلاج صوتي كرتوني
</div>
      </div>
    </div>
  </div>
  )
}

export default Details
